import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="32" viewBox="0 0 24 24" width="20" fill="currentColor">
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" />
  </svg>
);
